import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function GenerateBills() {
  const navigate = useNavigate();
  const [barangays, setBarangays] = useState([]);
  const [form, setForm] = useState({ barangay_id: '', billing_period: new Date().toISOString().slice(0, 7), previous_reading_date: '', current_reading_date: '', send_sms: false });
  const [generating, setGenerating] = useState(false);

  useEffect(() => { api.get('/barangays').then(r => setBarangays(r.data)); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGenerating(true);
    try {
      const r = await api.post('/bills/generate', { ...form, barangay_id: parseInt(form.barangay_id) });
      alert(r.data.message);
      navigate('/billing');
    } catch (e) { alert('Error: ' + e.message); }
    setGenerating(false);
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div>
      <h1 className="page-title">Generate Bills</h1>
      <div className="card" style={{ maxWidth: 500 }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Barangay *</label>
            <select className="input" value={form.barangay_id} onChange={e => set('barangay_id', e.target.value)} required>
              <option value="">Select...</option>
              {barangays.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="label">Billing Period (YYYY-MM) *</label>
            <input className="input" type="month" value={form.billing_period} onChange={e => set('billing_period', e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="label">Previous Reading Date *</label>
            <input className="input" type="date" value={form.previous_reading_date} onChange={e => set('previous_reading_date', e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="label">Current Reading Date *</label>
            <input className="input" type="date" value={form.current_reading_date} onChange={e => set('current_reading_date', e.target.value)} required />
          </div>
          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.send_sms} onChange={e => set('send_sms', e.target.checked)} />
              <span style={{ fontSize: 14 }}>Send SMS bill notification to consumers</span>
            </label>
          </div>
          <button type="submit" className="btn btn-primary" disabled={generating}>{generating ? 'Generating...' : 'Generate Bills'}</button>
        </form>
      </div>
    </div>
  );
}
